import Vue from "vue"
import Router from "vue-router"

import Login from "./views/Login.vue"
import OrganizationIndex from "./views/Organization/Index.vue"
import ConsignmentStockIndex from "./views/ConsignmentStock/Index.vue"
import ConsignmentStockShow from "./views/ConsignmentStock/Show.vue"
import ConsignmentStockEdit from "./views/ConsignmentStock/Edit.vue"
import ConsignmentStockRenew from "./views/ConsignmentStock/Renew.vue"
import ConsignmentStockBill from "./views/ConsignmentStock/Bill.vue"

import auth from "./services/auth"
import request from "./services/request"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/login",
      component: Login,
    },

    {
      name: "organizations",
      path: "/organizations",
      component: OrganizationIndex,
    },
    // {
    //  name: "organization",
    //  path: "/organizations/:client_id",
    //  component: OrganizationShow,
    // },

    {
      name: "consignment_stocks",
      path: "/consignment_stocks",
      component: ConsignmentStockIndex,
    },

    {
      name: "consignment_stock",
      path: "/consignment_stocks/:id",
      component: ConsignmentStockShow,
      children: [
        {
          name: "consignment_stock_edit",
          path: "edit",
          component: ConsignmentStockEdit,
        },
        {
          name: "consignment_stock_renew",
          path: "renew",
          component: ConsignmentStockRenew,
        },
        {
          name: "consignment_stock_bill",
          path: "bill",
          component: ConsignmentStockBill,
        },
      ],
    },

    {
      path: "*",
      redirect: "/consignment_stocks",
    }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    if (auth.isAuthenticated()) {
      next("/")
    } else {
      next()
    }
  } else if (auth.isAuthenticated()) {
    next()
  } else {
    next("/login")
  }
})

request.onunauthorized = () => {
  router.go("/login")
}

export default router
